// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'

type Props = {
  row: Row<any>
  setItemIdToView?: (id: string) => void
}

const CustomRow: FC<Props> = ({row, setItemIdToView}) => {
  const clicked = (e: React.MouseEvent) => {
    if (e.target.id === 'row') setItemIdToView(row.original.id)
  }

  return (
    <tr
      onClick={(e) => (setItemIdToView ? clicked(e) : null)}
      {...row.getRowProps()}
      className='cursor-pointer even:bg-[#e6f2f2] odd:bg-white'
    >
      {row.cells.map((cell) => (
        <td
          {...cell.getCellProps()}
          className={clsx(
            'truncate max-w-[150px] overflow-hidden whitespace-nowrap px-4 py-2 text-sm text-gray-800',
            {
              'text-right min-w-[100px]': cell.column.id === 'actions',
            }
          )}
          id='row'
        >
          {cell.render('Cell')}
        </td>
      ))}
    </tr>
  )
}

export {CustomRow}
